import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

const Replacementpolicy = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }, []);
  return (
    <>
      <section style={{ paddingTop: "5rem" }}>
        <Container>
          <div className="policy">
            <div className="privacy">
              <h2>Return Policy </h2>
            </div>
            <h3>Return Policy </h3>
            <p style={{ textIndent: "1.5rem" }}>
              {" "}
              We offer returns within first 3 days from the date of your purchase. If 3 days have passed since your purchase, you will not be offered a return.
            </p>
            <h3>Refund policy</h3>
            <p style={{ textIndent: "1.5rem" }}>In case of any refunds approved it will take 3 days for the refund to be  credited to you. </p>
            <h3>Shipping Policy </h3>
            <p style={{ textIndent: "1.5rem" }}>The orders for the user are shipped through registered domestic courier companies and/or speed post only. Orders are delivered within 3 days from the date of the order and/or payment or as per the delivery date agreed at the time of order confirmation and delivering of the shipment, subject to courier company / post office norms. Platform Owner shall not be liable for any delay in delivery by the courier company / postal authority. </p>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Replacementpolicy;


